import { useEffect, useState } from 'react'
import { onAppVisibleMessage } from '../utils/sdk-messenger'
import usePageLoadAnalytics from '../../utils/hooks/usePageLoadAnalytics'

/**
 * Hook to listen for the `EMBEDDED_APP_VISIBLE` event and automatically trigger
 * the `usePageLoadAnalytics` when the embedded application becomes visible to the user.
 */
const useAppVisibleChecker = (userIdReady: boolean) => {
  const [isAppVisible, setIsAppVisible] = useState(false)

  useEffect(() => {
    // Listen for the `EMBEDDED_APP_VISIBLE` message from the parent iframe
    onAppVisibleMessage(() => {
      setIsAppVisible(true)
    })
  }, [])

  // Pass the visibility state to usePageLoadAnalytics
  usePageLoadAnalytics(isAppVisible && userIdReady)

  return isAppVisible
}

export default useAppVisibleChecker
